<template>
  <div class="chart-page-layout"
       v-show="thisArg.option.showPage ? thisArg.option.autoPage ? thisArg.isHovering : true : false">
    <el-button @click="thisArg.prePage" type="primary" :icon="ArrowLeft"></el-button>
    <span style="padding: 0 10px">{{ thisArg.pageIndex }} / {{ thisArg.pageCount }}</span>
    <el-button @click="thisArg.nextPage" type="primary" :icon="ArrowRight">
    </el-button>
  </div>
</template>
<script setup>
import {
  ArrowLeft,
  ArrowRight,
} from '@element-plus/icons-vue'

const props = defineProps({
  thisArg: {}
})
</script>
<style lang="scss">
.chart-page-layout {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>